import styled from 'styled-components';

export const SearchBugStyled = styled.div`
  // to keep same width of popup
  // as content is dynamic f.ex sometimes is 300, 400, 528
  // and this prevent unexpected width changes
  width: 420px;

  @media (min-width: 768px) {
    width: 550px;
  }
`;

export const IssuesListStyled = styled.div`
  margin: 0 -24px;
  // because of height elements inside (4x52) prevent scroll
  max-height: 208px;
  overflow-x: none;
  overflow-y: auto;
`;

export const IssuesListRowStyled = styled.button`
  padding: 0 24px;
  display: block;
  width: 100%;
  border-radius: 0;
  border: 0;
  background: none;
  margin: 0;
  cursor: pointer;

  &:focus-within,
  &:hover {
    background: var(--ds-surface-hovered, var(--ds-fb-surface-hovered));
  }
`;

export const CreateNewWrapperStyled = styled.div`
  padding: 12px 0;
`;
